import React from 'react';

import { Tooltip } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';

const FolderDownloadScheduledIcon = (props) => {
  const { visible = false } = props;

  return visible ? (
    <Tooltip title='Download Scheduled'>
      <ClockCircleOutlined
        style={{ fontSize: 18, color: '#333', marginTop: 2 }}
      />
    </Tooltip>
  ) : null;
};

export default FolderDownloadScheduledIcon;
